import { type ReactNode } from 'react';
import { StyledError } from './FormError.styles';

interface FormErrorProps {
  children: ReactNode;
}

const FormError = ({ children }: FormErrorProps) => <StyledError>{children}</StyledError>;

export default FormError;
